<template>
    
    <div class="mod-sys__slcustomer}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">

        
        <el-form-item>
          <el-input v-model="dataForm.brokerName" placeholder="经纪人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.brokerMobile" placeholder="经纪人手机号" clearable></el-input>
        </el-form-item>
      
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slcustomer:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="brokerName" label="经纪人姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="brokerMobile" label="手机号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="money" label="金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="showStatus"  label="提现状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ geteducation(scope.row.showStatus,'status') }}
          </template>
        </el-table-column>
        <el-table-column prop="addTime"  label="审批时间" header-align="center" align="center"></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slaccountlog/page',
        getDataListIsPage: true,
        exportURL: '/sys/slaccountlog/export',
        deleteURL: '/sys/slaccountlog',
        deleteIsBatch: true
      },
      date: '',
      userTypes: [],
      statusList: [
        // {
        //   label: '不可提现',
        //   value: '0',
        // },
        // {
        //   label: '可提现',
        //   value: '0',
        // },

      ],
      dataForm: {
        brokerName: '',
        brokerMobile: '',
        paymentsType: 1,
      }
    }
  },
  created(){
    this.getuserTypeOptions()
    this.getentryStatusOptions()
  },

  methods: {
    //修改状态
    submitStatus(row){
      console.log(this.dataList.findIndex(item => item.id == row.id))
      let n = this.dataList.findIndex(item => item.id == row.id)
      this.$set(this.dataList,n,{...this.dataList[n],myishsow: !this.dataList[n].myishsow})
      if(row.myishsow){
        console.log(this.dataList)
      }
    },
    geteducation(v,name){
      if(name == 'userType')  return this.userTypes.filter(item => item.value == v)[0]?.label ;
      if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
      if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
      if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
      if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      if(name == 'status') return this.statusList.filter(item => item.value == v)[0]?.label ;
    },
      //利⽤change事件监听表单内容变化，并将选中的值赋值给所需要的两个字段
    //⽀付时间戳设置
    getTimes() {
      if (this.date != null) {
        this.dataForm.start = this.date[0]
        this.dataForm.end = this.date[1]
      }else{
        delete this.dataForm.startDate 
          delete this.dataForm.endDate
      }
    },

       //初始用户类型名称下拉框中的选项
       async getuserTypeOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=userType`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.userTypes = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.userTypes.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      //初始进件状态下拉框中的选项
      async getentryStatusOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=shareProfit`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.statusList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.statusList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
              console.log(this.statusList,'this.statusList')
          }).catch(() => {})
      },
  },
  components: {
    // AddOrUpdate
  }
}
</script>
